import { SET_DEVICE_TYPE_FILTER } from "../types"

const initialState = {
  deviceTypeFilter: [],
}

const deviceTypeReducer = (state = initialState, action) => { 
  switch (action.type) {
    case SET_DEVICE_TYPE_FILTER:
      return {
        ...state,
        deviceTypeFilter: action.payload,
      }
    default:
      return state
  }
}

export default deviceTypeReducer
